'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const SeoLink = require('./SeoLink');

function getSeoLinks(links) {
    return links.map((link, i) => {
        return <SeoLink key={i} link={link} />;
    });
}

const SeoLinks = React.createClass({
    propTypes: {
        links: PropTypes.array.isRequired
    },

    render() {
        return (
            <div className="seo-links">
                <div className="header-primary-large seo-links-title">more ways to browse</div>
                <ul className="seo-links-inner rowFlex">
                    {getSeoLinks(this.props.links)}
                </ul>
            </div>

        );
    }
});

module.exports = SeoLinks;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/SeoLinks/SeoLinks.jsx